(function() {
    'use strict';

    angular
        .module('parking')
        .service('parkingDetailsService', parkingDetailsService);


    function parkingDetailsService($http, $cacheFactory, $q, broker) {
        const url = '/api2/airportparking/details/';
        let timeout;
        const promiseCache = $cacheFactory.get('detailPromiseCache') || $cacheFactory('detailPromiseCache');

        const service = {
            getParkingDetails,
            appendDetails,
            rehydrate
        };

        function getParkingDetails(quote) {
            if (quote.AirportParkingQuoteId.Details) {
                return $q.when(quote.AirportParkingQuoteId.Details);
            }
            if (timeout != null) {
                timeout.resolve('CANCELLED');
            }
            const request = {
                AvailabilitySearchId: quote.AvailabilitySearchId,
                AirportParkingQuoteId: quote.AirportParkingQuoteId,
                DomainId: TRPCONFIG.Domain.DomainId
            };
            timeout = $q.defer();
            return $http.post(`${url}get`, request, {
                customErrCallback(args) {
                    if (args.status) {
                        broker.publish('parkingRequestFailed');
                    }
                    return true;
                },
                timeout: timeout.promise
            }).then(function(res) {
                promiseCache.remove(res.data.DetailsSearchId);
                timeout = null;
                return res.data;
            });
        }

        function appendDetails(quote, t) {
            if (!quote.Details) {
                quote.parkingBusy = true;
                const parkingSearchId = t.ParkingRequest.AvailabilitySearchId;
                service.getParkingDetails({ AvailabilitySearchId: parkingSearchId, AirportParkingQuoteId: quote.QuoteId }, true).then(function(d) {
                    quote.viewDetails = true;
                    quote.Details = d;
                    quote.parkingBusy = false;
                    quote.showDetailsError = false;
                }, function() {
                    quote.parkingBusy = false;
                    quote.showDetailsError = true;
                });
            } else {
                quote.viewDetails = true;
            }
        }

        function rehydrate(id) {
            if (!promiseCache.get(id)) {
                promiseCache.put(id, $http.post(`${url}getfromsession`, { DetailsSearchId: id }).then(function(res) {
                    return res.data;
                }));
            }
            return promiseCache.get(id);
        }

        return service;
    }
})();
